<template>
   <v-container>
      <v-sheet>
         <v-tabs
            height="40"
            v-model="vendortab"
            :slider-color="$globalstore.tab_slidercolor"
         >
            <v-tab href="#today">Today</v-tab>
            <v-tab href="#term">Term</v-tab>
         </v-tabs>
         <v-tabs-items v-model="vendortab">
            <v-tab-item :key="1" value="today">
               <v-row>
                  <v-col cols="12" md="8">
                     <v-card v-for="grp in groupinfo" :key="grp.cca_id">
                        <v-card-title>
                           {{ grp.cca_name }}
                           <v-card-subtitle v-if="grp.eventdata.length == 0">
                              No events scheduled for today
                           </v-card-subtitle>
                        </v-card-title>
                        <v-row
                           class="pl-5"
                           v-for="evt in grp.eventdata"
                           :key="evt.event_id"
                        >
                           <tr class="pl-2 my-1">
                              <td width="100px" height="40px">
                                 {{ evt.event_date }}
                              </td>
                              <td width="100px">{{ evt.event_starttime }}</td>
                              <td width="100px">{{ evt.event_endtime }}</td>
                           </tr>
                           <v-btn
                              color="primary"
                              :disabled="checktime(evt)"
                              @click="
                                 doAttendance(
                                    grp.cca_id,
                                    evt.event_id,
                                    evt.event_date
                                 )
                              "
                              ><v-icon>mdi-account-outline</v-icon>
                              Attendance
                           </v-btn>
                        </v-row>
                     </v-card>
                  </v-col>
               </v-row>
            </v-tab-item>
            <v-tab-item :key="2" value="term">
               <v-col cols="12" md="8">
                  <v-expansion-panels
                     v-model="panelarray"
                     active-class="panel-active"
                  >
                     <v-expansion-panel
                        v-for="grp in termschedule"
                        :key="grp.cca_id"
                     >
                        <v-expansion-panel-header>
                           {{ grp.cca_name }}<br />
                           {{ grp.cca_description }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                           <v-data-table
                              dense
                              :items="grp.eventdata"
                              :headers="event_headers"
                              @click:row="tableRowClick"
                              item-key="event_id"
                              single-select
                           >
                           </v-data-table>
                        </v-expansion-panel-content>
                     </v-expansion-panel>
                  </v-expansion-panels>
               </v-col>
            </v-tab-item>
         </v-tabs-items>
      </v-sheet>
   </v-container>
</template>

<script>
   export default {
      inject: ["ShowMessage"],

      data() {
         return {
            vendortab: "",
            groupinfo: [],
            termschedule: [],
            panelarray: [],
            event_headers: [
               {
                  text: "Date",
                  value: "event_date",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Start",
                  value: "event_starttime",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "End",
                  value: "event_endtime",
                  class: this.$globalstore.table_headerclass,
               },
            ],
         };
      },

      methods: {
         async loadVendorGroups() {
            let response = await this.$http({
               url: "/cca/gettodaygroup_byadmid.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  date: this.$globalstore.currentDateISOString().substr(0, 10),
                  id: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror)
                  this.$globalstore.user.tokenexpired = true;
               else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.groupinfo = response.data.groupdata;
                     if (this.groupinfo.length == 0) {
                        this.ShowMessage({
                           title: "Info",
                           message: "No groups assigned.",
                           color: "primary",
                        });
                     }
                  }
               }
            });
         },

         tableRowClick(item, row) {
            row.select(!row.isSelected);
         },

         async loadVendorFullTerm() {
            let response = await this.$http({
               url: "/cca/getvendortermschedule.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  vendorid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror)
                  this.$globalstore.user.tokenexpired = true;
               else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.messaeg,
                        color: "red",
                     });
                  } else {
                     this.termschedule = response.data.scheduledata;
                  }
               }
            });
         },

         checktime(evt) {
            return !this.checkstartend(evt.event_starttime, evt.event_endtime);
         },

         addMinutes(time, minsToAdd) {
            function D(J) {
               return (J < 10 ? "0" : "") + J;
            }
            var piece = time.split(":");

            var mins = piece[0] * 60 + +piece[1] + +minsToAdd;

            return D(((mins % (24 * 60)) / 60) | 0) + ":" + D(mins % 60);
         },

         checkstartend(start, end) {
            if (
               !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(start) ||
               !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(end)
            ) {
               return false;
            }
            let gracetime = this.$globalstore.appsettings
               .attendance_grace_minute;

            let now = this.getCurrentTime();
            console.log("now ", now);
            if (this.addMinutes(start, -gracetime) > now) {
               // current time is not within gracetime of start time
               console.log(
                  "current time is not within gracetime of start time"
               );
               return false;
            } else if (this.addMinutes(end, +gracetime) < now) {
               // current time is more than end time including grace time
               console.log(
                  "current time is more than end time including grace time"
               );
               console.log("end = ", this.addMinutes(end, +gracetime));

               return false;
            } else {
               // current time must be within start and end including grace
               console.log(
                  "current time must be within start and end including grace"
               );
               return true;
            }
         },

         getCurrentTime() {
            let now = new Date()
               .toLocaleTimeString("en-US", {hour12: false})
               .substr(0, 5);
            return now;
         },
         doAttendance(ccaid, eventid, eventdate) {
            console.log("ccaid ", ccaid);
            this.$router.push({
               name: "VendorAttendance",
               params: {eventid: eventid, ccaid: ccaid, eventdate: eventdate},
            });
         },
      },
      mounted() {
         this.loadVendorGroups();
         this.loadVendorFullTerm();
      },
   };
</script>

<style>
   .panel-active {
      background-color: rgb(194, 225, 245) !important;
   }
</style>
